import { render, staticRenderFns } from "./widgetFwAllowTop10.vue?vue&type=template&id=14188a8b&scoped=true&"
import script from "./widgetFwAllowTop10.vue?vue&type=script&lang=js&"
export * from "./widgetFwAllowTop10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14188a8b",
  null
  
)

export default component.exports